export { default } from './FreeTrial';



// WEBPACK FOOTER //
// ./src/components/templates/FreeTrial/index.js